import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { checkbox1, checkbox2, checkbox3, checkbox4, checkbox5, organizeName, taxId },
} = checkout;

const validation = Yup.object().shape({
  [checkbox1.name]: Yup.boolean(),
  [checkbox2.name]: Yup.boolean(),
  [checkbox3.name]: Yup.boolean(),
  [checkbox4.name]: Yup.boolean(),
  [checkbox5.name]: Yup.boolean(),
  [organizeName.name]: Yup.string().required(organizeName.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
